module.exports = __webpack_public_path__ + "static/media/blackWhiteShareIcon.f68924a1.svg";